import { Resources } from 'constants/resources';

import { AxiosError, AxiosResponse } from 'axios';
import { axios } from 'config/axios';
import qs from 'qs';
import { Commission } from 'types/embedded/commission';
import {
  ConditionGroup,
  ExpressionParam,
  ExpressionParamWithData,
  GatewayRule,
} from 'types/embedded/gatewayRule';
import { getId } from 'utils';
import { removeActivePrefix } from 'utils/removeActivePrefix';
import { removeKeys } from 'utils/removeKyes';

export const getConditionGroups = async (id: string): Promise<ConditionGroup> => {
  return axios
    .get(`condition_groups/${getId(id)}`, {
      headers: {
        Accept: 'application/ld+json',
      },
    })
    .then(({ data }: AxiosResponse) => {
      // ToDo при удалении флага wppa-4764-enum-expression удалить эту функция и возвращать просто data
      // на время удаления флага бэкенд еще присылает параметр comparisonOperatorNew. Поэтому на данном этапе выпилить нельзя.
      // проверить позже и удалить.
      const filteredFormValues = removeKeys(data, ['comparisonOperatorNew']);

      return filteredFormValues as any;
    })
    .catch((error: AxiosError) => Promise.reject(error.message));
};

export const getExpressionParams = async (): Promise<ExpressionParam[]> => {
  return axios
    .get('expression_params')
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.message));
};

export const getExpressionParamWithData = async (
  expressionAlias: string,
): Promise<ExpressionParamWithData> => {
  return axios
    .get(`expression_param_with_data/${expressionAlias}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.message));
};

export type ChangeMappingActivityResponse = { id: number; active: boolean };

export const changeMappingActivity = async (
  id?: string,
  active?: boolean,
): Promise<AxiosResponse<ChangeMappingActivityResponse>> => {
  return axios
    .patch(
      `mappings/${id}/change_activity`,
      { active },
      {
        headers: {
          'content-type': 'application/merge-patch+json',
        },
      },
    )
    .then((response: AxiosResponse) => response)
    .catch((error: AxiosError<{ detail: string }>) =>
      Promise.reject(removeActivePrefix(error.response?.data.detail)),
    );
};

export const deleteGatewayRules = async (id?: string): Promise<AxiosResponse> => {
  return axios
    .delete(`${Resources.GatewayRules}/${getId(id)}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError<{ detail: string }>) =>
      Promise.reject(removeActivePrefix(error.response?.data.detail)),
    );
};

export const updateGatewayRuleActive = async (
  id?: string,
  active?: boolean,
): Promise<GatewayRule> => {
  return axios
    .put(`${Resources.GatewayRules}/${getId(id)}`, { active })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError<{ detail: string }>) =>
      Promise.reject(removeActivePrefix(error.response?.data.detail)),
    );
};

export type AvailableCommissionsFilter = {
  merchant: string;
  gateways: string;
  transactionTypes: string[] | null;
  currency?: string;
};

export const getAvailableCommissions = async (
  filter: AvailableCommissionsFilter,
): Promise<Partial<Commission>[]> => {
  const params = qs.stringify(
    {
      ...filter,
    },
    { arrayFormat: 'indices', encode: true },
  );
  return axios
    .get(`commission/available_to_implement?${params}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
